import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private socket!: WebSocket;
  private messageSubject: Subject<any> = new Subject();

  constructor() {
    const token:string = localStorage.getItem('token') ?? '';
    const protocols = ['Authorization', token];
    this.socket = new WebSocket(environment.socketIoUrl, protocols);

    this.socket.onopen = () => {
      console.log('Connexion WebSocket ouverte');
    };

    this.socket.onmessage = (event: MessageEvent<any>) => {
      const data = event.data;
      const msg = JSON.parse(data);
      this.messageSubject.next(msg);
    };

    this.socket.onerror = (error: Event) => {
      console.error('Erreur WebSocket :', error);
    };

    this.socket.onclose = () => {
      console.log('Connexion WebSocket fermée');
    };
  }


  get messages$(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  sendMessage(message: any): void {
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ ...message }));
    } else {
      console.error("Impossible d'envoyer, le socket n'est pas connecté.");
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
    }
  }
}
